import { TextField, NumberField, TextInput } from "react-admin";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { MyList } from "../ra-lb-tools/components/myList";
import { TowerField, TowerInput } from "./tower/towers";
import { MyDateField } from "../ra-lb-tools/components/myDateField";
import { UserInput } from "./users";
import { MyReferenceInput } from "../ra-lb-tools/components/myReference";

export const KeyIcon = VpnKeyIcon;

const filters = () => [
  <TextInput source="id" alwaysOn key="id" />,
  <TowerInput source="tower_id" alwaysOn key="tower_id" />,
  <UserInput source="owner_id" alwaysOn key="owner_id" />,
  <MyReferenceInput reference="key-slots" source="slot" alwaysOn key="slot" />,
  <MyReferenceInput
    reference="key-rotations"
    source="rotation"
    alwaysOn
    key="rotation"
  />,
  <MyReferenceInput
    reference="key-status"
    source="status"
    alwaysOn
    key="status"
  />,
];

export const KeyList = (props) => {
  return (
    <MyList resource="keys" {...props} filters={filters()}>
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="slot" />
      <TowerField source="towerId" />
      <TextField source="typeName" label="Type" sortable={false} />
      <TextField source="rotationName" label="Rotation" sortable={false} />
      <TextField source="statusName" label="Status" sortable={false} />
      <MyDateField source="validFrom" showTime={true} />
      <MyDateField source="validUntil" showTime={true} />
    </MyList>
  );
};
